import getFullPhone from '@/constants/utils/CRM/getFullPhone';
import { get } from 'lodash';

export default (student) => {
  student.$phone = getFullPhone(student.phone);
  student.birthday = { date: [get(student, 'birthDate', '')] };
  return student;
};
